import React, { useState } from "react";
import style from "./SidebarStyle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isLogoutHovered, setLogoutHovered] = useState(false);

  const menuItems = [
    { name: "Dashboard", icon: "🏠", path: "/dashboard" },
    { name: "Clientes", icon: "🏢", path: "/platforms" },
    { name: "Assinaturas", icon: "💳", path: "/subscriptions" }
  ];

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const logoutButtonStyle = {
    ...style.logoutButton,
    backgroundColor: isLogoutHovered ? "rgba(205, 76, 76, 0.1)" : "transparent",
    borderColor: isLogoutHovered ? "#CD4C4C" : "#30363D",
  };

  return (
    <aside style={style.container}>
      <div style={style.mainNav}>
        <div style={style.logo}>
          <img
            src="/imgs/logo.png"
            alt="Logo AI Platform"
            style={style.logoImage}
          />
          <span>Software House C.M.</span>
        </div>
        <nav style={style.nav}>
          <p style={style.menuTitle}>MENU</p>
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              style={
                location.pathname.startsWith(item.path)
                  ? { ...style.navItem, ...style.navItemActive }
                  : style.navItem
              }
            >
              <span style={style.navItemIcon}>{item.icon}</span>
              {item.name}
            </Link>
          ))}
        </nav>
      </div>

      <div style={style.bottomSection}>
        <button
          style={logoutButtonStyle}
          onClick={handleLogout}
          onMouseEnter={() => setLogoutHovered(true)}
          onMouseLeave={() => setLogoutHovered(false)}
        >
          <span style={style.navItemIcon}>🚪</span>
          Sair
        </button>
      </div>
    </aside>
  );
}
